import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Plus, Edit2, Trash2, Save, X } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AdminServices = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingService, setEditingService] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const emptyService = {
    key: '',
    icon: 'Zap',
    title_en: '',
    title_tr: '',
    description_en: '',
    description_tr: '',
    order: 0
  };

  useEffect(() => {
    fetchServices();
  }, []);

  const fetchServices = async () => {
    try {
      const token = localStorage.getItem('admin_token');
      const response = await axios.get(`${BACKEND_URL}/api/admin/services`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setServices(response.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      const token = localStorage.getItem('admin_token');
      if (editingService.id) {
        await axios.put(`${BACKEND_URL}/api/admin/services/${editingService.id}`, editingService, {
          headers: { Authorization: `Bearer ${token}` }
        });
        toast.success('Hizmet güncellendi');
      } else {
        await axios.post(`${BACKEND_URL}/api/admin/services`, editingService, {
          headers: { Authorization: `Bearer ${token}` }
        });
        toast.success('Hizmet eklendi');
      }
      setEditingService(null);
      setShowForm(false);
      fetchServices();
    } catch (error) {
      toast.error('Hata oluştu');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Bu hizmeti silmek istediğinizden emin misiniz?')) return;
    
    try {
      const token = localStorage.getItem('admin_token');
      await axios.delete(`${BACKEND_URL}/api/admin/services/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Hizmet silindi');
      fetchServices();
    } catch (error) {
      toast.error('Silme hatası');
    }
  };

  if (loading) return <div className="admin-loading">Yükleniyor...</div>;

  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <h1>Hizmetler Yönetimi</h1>
        <button
          onClick={() => {
            setEditingService(emptyService);
            setShowForm(true);
          }}
          className="btn-primary"
        >
          <Plus size={20} />
          Yeni Hizmet Ekle
        </button>
      </div>

      {showForm && (
        <div className="admin-modal">
          <div className="admin-modal-content">
            <div className="admin-modal-header">
              <h2>{editingService.id ? 'Hizmeti Düzenle' : 'Yeni Hizmet Ekle'}</h2>
              <button onClick={() => setShowForm(false)} className="modal-close">
                <X size={24} />
              </button>
            </div>

            <div className="admin-form">
              <div className="form-group">
                <label>Key (benzersiz)</label>
                <input
                  type="text"
                  value={editingService.key}
                  onChange={(e) => setEditingService({ ...editingService, key: e.target.value })}
                  className="form-input"
                />
              </div>

              <div className="form-group">
                <label>İkon</label>
                <input
                  type="text"
                  value={editingService.icon}
                  onChange={(e) => setEditingService({ ...editingService, icon: e.target.value })}
                  className="form-input"
                  placeholder="Zap, Briefcase, vb."
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Başlık (EN)</label>
                  <input
                    type="text"
                    value={editingService.title_en}
                    onChange={(e) => setEditingService({ ...editingService, title_en: e.target.value })}
                    className="form-input"
                  />
                </div>
                <div className="form-group">
                  <label>Başlık (TR)</label>
                  <input
                    type="text"
                    value={editingService.title_tr}
                    onChange={(e) => setEditingService({ ...editingService, title_tr: e.target.value })}
                    className="form-input"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Açıklama (EN)</label>
                  <textarea
                    value={editingService.description_en}
                    onChange={(e) => setEditingService({ ...editingService, description_en: e.target.value })}
                    rows="3"
                    className="form-textarea"
                  />
                </div>
                <div className="form-group">
                  <label>Açıklama (TR)</label>
                  <textarea
                    value={editingService.description_tr}
                    onChange={(e) => setEditingService({ ...editingService, description_tr: e.target.value })}
                    rows="3"
                    className="form-textarea"
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Sıra</label>
                <input
                  type="number"
                  value={editingService.order}
                  onChange={(e) => setEditingService({ ...editingService, order: parseInt(e.target.value) })}
                  className="form-input"
                />
              </div>

              <button onClick={handleSave} className="btn-primary">
                <Save size={20} />
                Kaydet
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="admin-table">
        <table>
          <thead>
            <tr>
              <th>Sıra</th>
              <th>Başlık (TR)</th>
              <th>Başlık (EN)</th>
              <th>İşlemler</th>
            </tr>
          </thead>
          <tbody>
            {services.map((service) => (
              <tr key={service.id}>
                <td>{service.order}</td>
                <td>{service.title_tr}</td>
                <td>{service.title_en}</td>
                <td>
                  <div className="table-actions">
                    <button
                      onClick={() => {
                        setEditingService(service);
                        setShowForm(true);
                      }}
                      className="btn-icon btn-edit"
                    >
                      <Edit2 size={18} />
                    </button>
                    <button
                      onClick={() => handleDelete(service.id)}
                      className="btn-icon btn-delete"
                    >
                      <Trash2 size={18} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminServices;
